const PERMISSION_ENUM = {
  ACCM: 'ACCM',
  GRAPHIC_DESIGNER: 'GRAPHIC_DESIGNER',
  CLIENT: 'CLIENT'
};

export default PERMISSION_ENUM;
